import React, { useState, useEffect } from "react";
import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import { State } from "../../store";
import { connect } from "react-redux";

import { Order, OrderResponse } from "../../models/Order";
import { Get } from "../../api/apiUtils";
import * as GeneralStore from "../../store/GeneralStore";

import "./OrdersPage.css";
import CpIcon from "./Icons";
import { Dropdown, IDropdownOption, IDropdownStyles } from "@fluentui/react";
import { SearchBox, ISearchBoxStyles } from "@fluentui/react/lib/SearchBox";

type Props = GeneralStore.GeneralState & typeof GeneralStore.actionCreators;

const OrdersPage: FC<Props> = (props: Props) => {
  const [activeSection, setActiveSection] = useState("upcoming");
  const [filteredWords, setFilteredWords] = useState<Order[]>([]);
  const [noResults, setNoResults] = useState(Boolean);
  const [orderData, setOrderData] = useState<Order[] | null>([]);
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(500);
  const [modality, setModality] = useState<number>(0);

  const getOrderResults = async () => {
    try {
      const response = await Get(
        `/api/Order?salesOrg=ALL&pageNo=${pageNo}&pageSize=${pageSize}&modality=${modality}`,
        false,
        true
      );

      if (!response.ok) {
        console.log("Error fetching data:", response.status);
        return;
      }

      const data: OrderResponse = await response.json();

      if (data.results.length > 0) {
        setOrderData(data.results);
        setFilteredWords(data.results);
      } else {
        console.log("No Data Found");
        setOrderData(null);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  useEffect(() => {
    getOrderResults();
  }, [pageNo, pageSize, modality]);

  const statusMap: Record<string, number> = {
    upcoming: 0,
    ongoing: 1,
    done: 2,
  };

  // Styles
  const searchbarStyles: ISearchBoxStyles = {
    root: {
      width: 300,
      height: 45,
      border: "1px solid lightgray ",
      borderRadius: "8px",
      selectors: {
        ":after": {
          border: "1px solid black",
          borderRadius: "8px",
        },
        ":hover": {
          border: "1px solid black",
          borderRadius: "8px",
        },
      },
    },
    field: {
      fontSize: "16px",
    },
    icon: {
      color: "black",
    },
  };
  const dropdownStyles: Partial<IDropdownStyles> = {
    root: {
      width: 100,
      marginLeft: 5,
      selectors: {
        "&:focus::after": {
          border: "none !important",
        },
      },
    },
    dropdown: {
      selectors: {
        "&:focus": {
          outline: "none",
        },
        "&:focus::after": {
          border: "none",
          outline: "none",
        },
      },
    },
    title: {
      borderRadius: "99px",
      borderColor: "transparent !important",
      outline: "none !important",
      backgroundColor: "#E5E5E5",
    },
  };
  // const datepickerStyles: IDatePickerStyles = {
  //   root: {
  //     width: 100,
  //     border: "none",
  //     outline: "none",
  //     borderColor: "red",
  //     borderRadius: "8px",
  //     selectors: {
  //       border: "none",
  //       outline: "none",
  //       ":hover": { border: "none", outline: "none" },
  //       ":focus": { border: "none", outline: "none" },
  //     },
  //   },
  //   textField: {
  //     border: "none",
  //     outline: "none",
  //     selectors: {
  //       ":focus": { border: "none", outline: "none" },
  //       ":hover": { border: "none", outline: "none" },
  //     },
  //   },
  //   callout: {
  //     border: "none",
  //     outline: "none",
  //     selectors: {
  //       ":focus": { border: "none", outline: "none" },
  //       ":hover": { border: "none", outline: "none" },
  //     },
  //   },
  //   icon: {
  //     display: "none",
  //   },
  // };

  const modalityOptions: IDropdownOption[] = [
    { key: 0, text: "Marine" },
    { key: 1, text: "Truck" },
    { key: 2, text: "Rail" },
  ];

  // Functions
  const sectionClick = (section: string) => {
    setActiveSection(section);

    if (!orderData) return;

    const filteredOrders = orderData.filter(
      (order) =>
        order.nomination.status === statusMap[section] &&
        Number(order.nomination.modality) === modality
    );

    setFilteredWords(filteredOrders);
    setNoResults(filteredOrders.length === 0);
  };
  const searchFilter = (
    event?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    const value = event?.target.value ?? newValue ?? "";

    if (!orderData?.length) return;

    if (value.trim() === "") {
      setFilteredWords(orderData);
      setNoResults(false);
    } else {
      const filtered = orderData.filter(
        (order) =>
          order.nomination.product
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          order.nominationNo.toLowerCase().includes(value.toLowerCase())
      );

      setFilteredWords(filtered);
      setNoResults(filtered.length === 0);
    }
  };

  const handleModalityChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {
    if (option) {
      setModality(Number(option.key));
    }
  };

  return (
    <>
      <div className="container-order">
        <div className="header-container">
          <div className="order-name-space">Orders</div>
          <div className="order-header-buttons-box">
            <button
              onClick={() => sectionClick("upcoming")}
              className={
                activeSection === "upcoming"
                  ? "button-active"
                  : "button-inactive"
              }
            >
              Upcoming
            </button>
            <button
              onClick={() => sectionClick("ongoing")}
              className={
                activeSection === "ongoing"
                  ? "button-active"
                  : "button-inactive"
              }
            >
              On Going
            </button>
            <button
              onClick={() => sectionClick("done")}
              className={
                activeSection === "done" ? "button-active" : "button-inactive"
              }
            >
              Done
            </button>
          </div>
        </div>

        {activeSection === "upcoming" && (
          <div className="content-container">
            <div className="toolbar-header">
              <div className="search-bar-box">
                <SearchBox
                  placeholder="Search"
                  styles={searchbarStyles}
                  onChange={searchFilter}
                />
              </div>
              {/* <div className="filter-bar-box">
                <CpIcon iconName="DurationIcon" />
                <p>Duration: </p>
                <Dropdown
                  placeholder="Select"
                  options={options}
                  styles={dropdownStyles}
                />
              </div> */}
              <div className="filter-bar-box">
                <CpIcon iconName="ModalityIcon" />
                <p>Modality: </p>
                <Dropdown
                  placeholder="Select"
                  options={modalityOptions}
                  selectedKey={modality}
                  styles={dropdownStyles}
                  onChange={handleModalityChange}
                />
              </div>
              {/* <div className="filter-bar-box">
                <CpIcon iconName="SortIcon" />
                <p>Sort: </p>
                <Dropdown
                  placeholder="Select"
                  options={options}
                  styles={dropdownStyles}
                />
              </div> */}
              <div>
                <button className="filter-button-box">
                  <CpIcon iconName="FilterButtonIcon" />
                </button>
              </div>
            </div>
            <div className="listing-container">
              <table className="listing-table">
                <tbody className="listing-tbody">
                  {filteredWords && filteredWords.length > 0 ? (
                    filteredWords.map((orderData) => (
                      <tr key={orderData.nominationNo}>
                        <td>
                          <div className="listing-detail-container">
                            <div className="name-subname">
                              <span style={{ fontSize: "14px" }}>
                                {orderData.nomination.product}
                              </span>
                              <span
                                style={{ color: "#737373", fontSize: "12px" }}
                              >
                                {orderData.nominationNo}
                              </span>
                            </div>
                            <div className="listing-detail-box">
                              <div className="listing-box">
                                <CpIcon iconName="OpacityIcon" />
                                <p>{orderData.nomination.quantity}</p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="EventCalendarIcon" />
                                <p>
                                  {orderData.nomination.arrivalDate
                                    ? orderData.nomination.arrivalDate
                                    : "-"}
                                </p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="TankListingIcon" />
                                <p>{orderData.nomination.tank}</p>
                              </div>
                              <Link
                                to={`/customer/order/${orderData.orderNo}/details?modality=${modality}`}
                              >
                                <button className="buttonLink">
                                  <CpIcon iconName="ListingIcon" />
                                </button>
                              </Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No matching results found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeSection === "ongoing" && (
          <div className="content-container">
            <div className="toolbar-header">
              <div className="search-bar-box">
                <SearchBox
                  placeholder="Search"
                  styles={searchbarStyles}
                  onChange={searchFilter}
                />
              </div>
              {/* <div className="filter-bar-box">
              <CpIcon iconName="DurationIcon" />
              <p>Duration: </p>
              <Dropdown
                placeholder="Select"
                options={options}
                styles={dropdownStyles}
              />
            </div> */}
              <div className="filter-bar-box">
                <CpIcon iconName="ModalityIcon" />
                <p>Modality: </p>
                <Dropdown
                  placeholder="Select"
                  options={modalityOptions}
                  selectedKey={modality}
                  styles={dropdownStyles}
                  onChange={handleModalityChange}
                />
              </div>
              {/* <div className="filter-bar-box">
              <CpIcon iconName="SortIcon" />
              <p>Sort: </p>
              <Dropdown
                placeholder="Select"
                options={options}
                styles={dropdownStyles}
              />
            </div> */}
              <div>
                <button className="filter-button-box">
                  <CpIcon iconName="FilterButtonIcon" />
                </button>
              </div>
            </div>
            <div className="listing-container">
              <table className="listing-table">
                <tbody className="listing-tbody">
                  {filteredWords && filteredWords.length > 0 ? (
                    filteredWords.map((orderData) => (
                      <tr key={orderData.nominationNo}>
                        <td>
                          <div className="listing-detail-container">
                            <div className="name-subname">
                              <span style={{ fontSize: "14px" }}>
                                {orderData.nomination.product}
                              </span>
                              <span
                                style={{ color: "#737373", fontSize: "12px" }}
                              >
                                {orderData.nominationNo}
                              </span>
                            </div>
                            <div className="listing-detail-box">
                              <div className="listing-box">
                                <CpIcon iconName="OpacityIcon" />
                                <p>{orderData.nomination.quantity}</p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="EventCalendarIcon" />
                                <p>
                                  {orderData.nomination.arrivalDate
                                    ? orderData.nomination.arrivalDate
                                    : "-"}
                                </p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="TankListingIcon" />
                                <p>{orderData.nomination.tank}</p>
                              </div>
                              <Link
                                to={`/customer/order/${orderData.orderNo}/details?modality=${modality}`}
                              >
                                <button className="buttonLink">
                                  <CpIcon iconName="ListingIcon" />
                                </button>
                              </Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No matching results found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeSection === "done" && (
          <div className="content-container">
            <div className="toolbar-header">
              <div className="search-bar-box">
                <SearchBox
                  placeholder="Search"
                  styles={searchbarStyles}
                  onChange={searchFilter}
                />
              </div>
              {/* <div className="filter-bar-box">
              <CpIcon iconName="DurationIcon" />
              <p>Duration: </p>
              <Dropdown
                placeholder="Select"
                options={options}
                styles={dropdownStyles}
              />
            </div> */}
              <div className="filter-bar-box">
                <CpIcon iconName="ModalityIcon" />
                <p>Modality: </p>
                <Dropdown
                  placeholder="Select"
                  options={modalityOptions}
                  selectedKey={modality}
                  styles={dropdownStyles}
                  onChange={handleModalityChange}
                />
              </div>
              {/* <div className="filter-bar-box">
              <CpIcon iconName="SortIcon" />
              <p>Sort: </p>
              <Dropdown
                placeholder="Select"
                options={options}
                styles={dropdownStyles}
              />
            </div> */}
              <div>
                <button className="filter-button-box">
                  <CpIcon iconName="FilterButtonIcon" />
                </button>
              </div>
            </div>
            <div className="listing-container">
              <table className="listing-table">
                <tbody className="listing-tbody">
                  {filteredWords && filteredWords.length > 0 ? (
                    filteredWords.map((orderData) => (
                      <tr key={orderData.nominationNo}>
                        <td>
                          <div className="listing-detail-container">
                            <div className="name-subname">
                              <span style={{ fontSize: "14px" }}>
                                {orderData.nomination.product}
                              </span>
                              <span
                                style={{ color: "#737373", fontSize: "12px" }}
                              >
                                {orderData.nominationNo}
                              </span>
                            </div>
                            <div className="listing-detail-box">
                              <div className="listing-box">
                                <CpIcon iconName="OpacityIcon" />
                                <p>{orderData.nomination.quantity}</p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="EventCalendarIcon" />
                                <p>
                                  {orderData.nomination.arrivalDate
                                    ? orderData.nomination.arrivalDate
                                    : "-"}
                                </p>
                              </div>
                              <div className="listing-box">
                                <CpIcon iconName="TankListingIcon" />
                                <p>{orderData.nomination.tank}</p>
                              </div>
                              <Link
                                to={`/customer/order/${orderData.orderNo}/details?modality=${modality}`}
                              >
                                <button className="buttonLink">
                                  <CpIcon iconName="ListingIcon" />
                                </button>
                              </Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No matching results found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general,
  }),
  {
    ...GeneralStore.actionCreators,
  }
)(OrdersPage);
